/* eslint-disable import/prefer-default-export */
import type { EventType } from "./event.type";

export const getEventTypesUrl = (eventType: EventType) => {
    const isAllTrue = Object.values(eventType).every((value) => {
        return value === true;
    });

    // 全てtrueの場合は、空の文字列を返す
    if (isAllTrue) return "";

    let url = "";

    if (eventType.event) {
        url += "&event_types[]=free_event";
    }

    if (eventType.streetLive) {
        url += "&event_types[]=street_event";
    }

    if (eventType.otherEvent) {
        url += "&event_types[]=other";
    }

    return url;
};

export const getArtistKeywordUrl = (artistKeyWord: string) => {
    if (artistKeyWord === "") return "";

    let url = "";

    const artistKeywordList = artistKeyWord.split(",");

    artistKeywordList.forEach((keyword) => {
        url += `&artists[]=${keyword}`;
    });

    return url;
};

export const getEventDateUrl = (eventDate: {
    startDate: string;
    endDate: string;
}) => {
    if (eventDate.startDate === "" || eventDate.endDate === "") return "";

    const url = `&date_from=${eventDate.startDate}&date_to=${eventDate.endDate}`;

    return url;
};
